import React from 'react';
import rowComponents from './rowComponents';
import ErrorRow from './ErrorRow';

/**
 * Renders a single table row based on its type and content.
 * Handles error cases such as missing type or invalid row objects.
 *
 * @param {Object} row - The data object representing the row.
 * @param {Array} columns - The list of columns to render.
 * @returns {JSX.Element | null} - The rendered row or an error row.
 */
const renderRow = (row, columns) => {
  // Validate if the row is a valid object
  if (!row || typeof row !== 'object') {
    return null;
  }

  // Validate if the row has a type
  if (!row.type) {
    return (
      <ErrorRow
        key={row.id}
        message="This row is missing some required information."
        columns={columns.length}
      />
    );
  }

  // Check if there is a component for the specified row type
  const RowComponent = rowComponents[row.type];
  if (!RowComponent) {
    return (
      <ErrorRow
        key={row.id}
        message="The content in this row cannot be displayed."
        columns={columns.length}
      />
    );
  }

  // Render the appropriate row component
  return <RowComponent key={row.id} data={row.data} {...row} />;
};

export default renderRow;
